import { useLanguageContext } from "../../Components/Languages/Langs/LanguageContext"
import { Footer } from "../../Components/Public/WelcomePage/Footer/Footer"
import { SignInHeader } from "./HeaderSignIn/SignInHeader"
import { SignInForm } from "./SignInForm/SignInForm"
import { ContainerSignInPage, MainContent, PageWrapper, TitleSignInPage } from "./SignInPageStyles.styled"

export const SignInPage = () => {
    const { t } = useLanguageContext();
    return (
        <>
            <PageWrapper>
                <SignInHeader />
                    <MainContent>
                        <ContainerSignInPage>
                            <TitleSignInPage>{t("publicTranslate.FormsAndModel.PageSignIn.TimeOut")} 😉</TitleSignInPage>
                        </ContainerSignInPage>
                        <SignInForm />
                    </MainContent>
                <Footer />
            </PageWrapper>
            
        </>
    )
}